import { UserUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/user_events_pb';
import { Col } from '@rematter/ui-web';
import { DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type UserUpdatedDetailProps = {
  event: UserUpdatedEvent;
};

export const UserUpdatedDetail = ({ event }: UserUpdatedDetailProps) => {
  const previous = event.previousUser;
  const current = event.updatedUser;

  if (!previous || !current) {
    return (
      <Col className="@UserUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'firstName',
      label: 'First Name',
      previous: previous.firstName,
      current: current.firstName,
    },
    {
      field: 'lastName',
      label: 'Last Name',
      previous: previous.lastName,
      current: current.lastName,
    },
    {
      field: 'email',
      label: 'Email',
      previous: previous.email,
      current: current.email,
    },
    {
      field: 'phoneNumber',
      label: 'Phone Number',
      previous: previous.phoneNumber,
      current: current.phoneNumber,
    },
    {
      field: 'timezone',
      label: 'Timezone',
      previous: previous.timezone?.name,
      current: current.timezone?.name,
    },
  ];

  return (
    <Col className="@UserUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">User</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Email" value={current.email} />
          <FieldDisplay
            label="Name"
            value={`${current.firstName} ${current.lastName}`}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
